<section class="container">
    <span>404</span>
    <span style="font-size: 20px;">{{ 'PAGE_NOT_FOUND_MESSAGE' | translate }}</span>
</section>
